<!-- 版本购买 -->
<template>
    <div class="content">
        <!-- <div class="title">查看版本对比<Icon type="ios-arrow-forward" size="14" class="title-icon"/></div> -->
        <div class="card-div">
            <div class="card">
                <div class="card-border1"></div>
                <div class="card-version">试用版</div>
                <div class="card-money">免费</div>
                <div class="p24">
                    <Button class="card-btn1">免费扫码2000次</Button>
                    <div class="flex-between"><div>生码量<span class="card-txt">(单独购买0.006一个)</span></div><div>100个</div></div>
                    <div class="flex-between"><div>水印</div><div>有水印</div></div>
                    <div class="flex-between">
                        <div>模板管理</div>
                        <div class="card-tip">2</div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-border2"></div>
                <div class="card-version">商业版</div>
                <div class="card-money">￥800<span class="card-money-txt"> / 年</span></div>
                <div class="p24">
                    <Button class="card-btn2" @click="openMoney(2)">再次续费</Button>
                    <div class="card-btn2-tip">包含试用版全部功能</div>
                    <div class="flex-between"><div>生码量<span class="card-txt">(单独购买0.005一个)</span></div><div>10万个</div></div>
                    <div class="flex-between"><div>水印</div><div>有水印</div></div>
                </div>
            </div>
            <div class="card">
                <div class="card-border3"></div>
                <div class="card-version">企业版</div>
                <div class="card-money">￥3800<span class="card-money-txt"> / 年</span></div>
                <div class="p24">
                    <Button class="card-btn3" @click="openMoney(3)">立即升级</Button>
                    <div class="card-btn3-tip">包含商业版全部功能</div>
                    <div class="flex-between"><div>生码量<span class="card-txt">(单独购买0.003一个)</span></div><div>100万个</div></div>
                    <div class="flex-between"><div>水印</div><div>有水印</div></div>
                    <div class="flex-between">空码绑定</div>
                    <div class="flex-between">PDA设备绑定</div>
                    <div class="flex-between">DIY模板</div>
                    <div class="flex-between">红包营销</div>
                    <div class="flex-between">
                        <div>主动发货和退货</div>
                        <div class="card-tip">3</div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-border4"></div>
                <div class="card-version">至尊版</div>
                <div class="card-money">￥6800<span class="card-money-txt"> / 年</span></div>
                <div class="p24">
                    <Button class="card-btn4" @click="openMoney(4)">立即升级</Button>
                    <div class="card-btn4-tip">包含企业版全部功能</div>
                    <div class="flex-between"><div>生码量</div><div>不限</div></div>
                    <div class="flex-between">
                        <div>代理商&门店端</div>
                        <div class="card-tip">4</div>
                    </div>
                    <div class="flex-between">
                        <div>装箱操作管理</div>
                        <div class="card-tip">6</div>
                    </div>
                </div>
            </div>
            <div class="card card-none">
                <div class="card-border5"></div>
                <div class="card-version">源码、二开</div>
                <div class="card-money">￥9800<span class="card-money-txt"> / 年 起</span></div>
                <div class="p24">
                    <Button class="card-btn5" @click="openMoney(5)">联系客服</Button>
                    <div class="card-btn5-tip">包含商至尊版全部功能</div>
                    <div class="flex-between">独立部署</div>
                </div>
            </div>
        </div>
        <div class="card-title">版本对比</div>
        <img src="@/assets/example.png" alt="" class="card-img">
        <!-- 升级版本 -->
        <Modal v-model="money_modal" title="升级版本" width="777" :mask-closable="false">
            <div class="flex-div">
                <div class="money-card1">企业版</div>
                <div class="money-div">
                    <div class="money-title">订单详情</div>
                    <div class="money-text">订单类型：升级版本</div>
                    <div class="money-text">订购版本：企业版 PRO</div>
                    <div class="money-text">订购时长：1 年</div>
                    <div class="money-text">预期生效时间：付款后立即生效</div>
                    <div class="money-card2">
                        <div>支付方式</div>
                        <div></div>
                    </div>
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
    </div>
</template>

<script>
// import { action_index } from "@/api/index";
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 30,
            },
            total: 0,
            money_modal: false,
        };
    },
    mounted() {
        // this.getList();
    },
    methods: {
        getList() {
            action_index(this.storePrams).then((res) => {
            });
        },
        openMoney(i){
            // i == 3: 企业版; i == 4: 至尊版; i == 5: 源码、二开;
            this.money_modal = true;
        },
    },
};
</script>

<style scoped>
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.card-div {
    display: flex;
    flex-wrap: wrap;
}
.card {
    width: 250px;
    min-height: 300px;
    background: #FFFFFF;
    box-shadow: 0px 0px 24px 0px #DCDCDC;
    border-radius: 10px;
    text-align: center;
    padding-bottom: 24px;
    margin: 0 24px 24px 0;
}
.card-none {
    margin-right: 0;
}
.card-border1 {
    width: 100%;
    height: 12px;
    background: #AEAEAE;
    border-radius: 10px 10px 0px 0px;
}
.card-btn1 {
    margin: 12px 0 24px 0;
    background: #AEAEAE;
    border: 1px solid #AEAEAE;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 13px;
    color: #FFFFFF;
    width: 100%;
    border-radius: 5px;
}
.card-border2 {
    width: 100%;
    height: 12px;
    background: #FF761D;
    border-radius: 10px 10px 0px 0px;
}
.card-btn2 {
    margin: 12px 0 6px 0;
    background: #FF761D;
    border: 1px solid #FF761D;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 13px;
    color: #FFFFFF;
    width: 100%;
    border-radius: 5px;
}
.card-btn2-tip {
    width: 100%;
    background: rgba(203,255,203,0.26);
    border-radius: 10px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #179958;
    margin-bottom: 12px;
    text-align: left;
    padding: 6px 12px;
}
.card-border3 {
    width: 100%;
    height: 12px;
    background: #179958;
    border-radius: 10px 10px 0px 0px;
}
.card-btn3 {
    margin: 12px 0 6px 0;
    background: #179958;
    border: 1px solid #179958;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 13px;
    color: #FFFFFF;
    width: 100%;
    border-radius: 5px;
}
.card-btn3-tip {
    width: 100%;
    background: rgba(203,255,203,0.26);
    border-radius: 10px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #179958;
    margin-bottom: 12px;
    text-align: left;
    padding: 6px 12px;
}
.card-border4 {
    width: 100%;
    height: 12px;
    background: #3670F7;
    border-radius: 10px 10px 0px 0px;
}
.card-btn4 {
    margin: 12px 0 6px 0;
    background: #3670F7;
    border: 1px solid #3670F7;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 13px;
    color: #FFFFFF;
    width: 100%;
    border-radius: 5px;
}
.card-btn4-tip {
    width: 100%;
    background: rgba(54,112,247,0.09);
    border-radius: 10px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #3670F7;
    margin-bottom: 12px;
    text-align: left;
    padding: 6px 12px;
}
.card-border5 {
    width: 100%;
    height: 12px;
    background: #262626;
    border-radius: 10px 10px 0px 0px;
}
.card-btn5 {
    margin: 12px 0 6px 0;
    background: #262626;
    border: 1px solid #262626;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 13px;
    color: #FFFFFF;
    width: 100%;
    border-radius: 5px;
}
.card-btn5-tip {
    width: 100%;
    background: rgba(38,38,38,0.09);
    border-radius: 10px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #262626;
    margin-bottom: 12px;
    text-align: left;
    padding: 6px 12px;
}
.card-version {
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 20px;
    color: #010101;
    margin: 12px 0;
}
.card-money {
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 24px;
    color: #010101;
}
.card-money-txt {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #010101;
}
.p24 {
    padding: 0 24px;
}
.flex-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    margin-bottom: 3px;
}
.card-tip {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 10px;
    color: #666666;
    border: 1px solid #666666;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    margin-right: 6px;
}
.padding-left-12 {
    padding-left: 12px;
}
.flex-div {
    display: flex;
}
.money-div {
    margin-left: 12px;
    padding: 24px 0;
}
.money-title {
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 16px;
    color: #010101;
    margin-bottom: 24px;
}
.money-text {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    margin-bottom: 24px;
}
.money-card1 {
    width: 300px;
    height: 500px;
    background: #F9FEF9;
    border-radius: 10px;
    border: 1px solid #D2D5E0;
}
.money-card2 {
    width: 400px;
    height: 200px;
    background: #F9FEF9;
    border-radius: 10px;
    border: 1px solid #D2D5E0;
}
.card-txt {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 11px;
    color: #666666;
}
.card-title {
    margin: 12px 0;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 33px;
    color: #333;
    text-align: center;
}
.card-img {
    width: 100%;
    height: 600px;
}
</style>